import { SidebarIconProps } from "../../../types";

export default function SurveyIcon({ collapsed }: SidebarIconProps) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={collapsed ? "" : "relative left-[6px] scale-[1.2]"}
      >
        <path
          d="M6.1921 12.7418C6.46862 13.5268 6.91579 14.2407 7.5014 14.8321C8.08702 15.4235 8.7965 15.8776 9.57875 16.1618C10.361 16.446 11.1965 16.5532 12.0252 16.4757C12.8539 16.3981 13.655 16.1378 14.3709 15.7134L16.3137 16.2684C16.3941 16.2913 16.4791 16.2924 16.5601 16.2714C16.641 16.2505 16.7148 16.2082 16.7739 16.1491C16.833 16.09 16.8753 16.0162 16.8962 15.9352C16.9172 15.8543 16.9162 15.7693 16.8932 15.6889L16.3381 13.7461C16.8313 12.9144 17.1018 11.9696 17.1236 11.0028C17.1453 10.0361 16.9175 9.08005 16.4621 8.22698C16.0068 7.37391 15.3393 6.6526 14.524 6.13262C13.7087 5.61265 12.7732 5.31157 11.8076 5.25844M1.66182 9.99615C0.962948 8.81803 0.718199 7.4253 0.973527 6.07949C1.22886 4.73368 1.9667 3.52737 3.0485 2.68708C4.1303 1.84679 5.48165 1.43031 6.84879 1.51587C8.21593 1.60142 9.50482 2.18311 10.4734 3.15171C11.442 4.12032 12.0237 5.4092 12.1093 6.77634C12.1948 8.14348 11.7784 9.49483 10.9381 10.5766C10.0978 11.6584 8.8915 12.3963 7.54569 12.6516C6.19988 12.907 4.80715 12.6622 3.62903 11.9634L1.68627 12.5184C1.6059 12.5413 1.52084 12.5424 1.43992 12.5214C1.35899 12.5005 1.28515 12.4582 1.22604 12.3991C1.16693 12.34 1.1247 12.2662 1.10373 12.1852C1.08277 12.1043 1.08382 12.0193 1.10678 11.9389L1.66182 9.99615Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
